module.exports = __webpack_public_path__ + "static/media/user.f1a107bb.svg";